var ANIMATION_FUNCTION = 'cubic-bezier(0.14, 1.12, 0.67, 0.99)';
var DEFAULT_ANIMATION_DURATION = '0.3s';

function normalizeTransitionProps(transition) {
  return typeof transition === 'string' ? {
    name: transition,
    duration: DEFAULT_ANIMATION_DURATION
  } : Object.assign({}, transition, {
    duration: transition.duration || DEFAULT_ANIMATION_DURATION
  });
}

function createTransitionForProperty(transition) {
  var _normalizeTransitionP = normalizeTransitionProps(transition),
      name = _normalizeTransitionP.name,
      duration = _normalizeTransitionP.duration,
      delay = _normalizeTransitionP.delay;

  var delayToAppend = delay ? " ".concat(delay) : '';
  return "".concat(name, " ").concat(duration, " ").concat(ANIMATION_FUNCTION).concat(delayToAppend);
}

export function createElectricTransition() {
  for (var _len = arguments.length, transitions = new Array(_len), _key = 0; _key < _len; _key++) {
    transitions[_key] = arguments[_key];
  }

  return transitions.length > 0 ? "transition: ".concat(transitions.map(createTransitionForProperty).join(', ')) : undefined;
}